import { ICouponCard } from "@swiggy-private/core-ui";
import { CART_RELOAD_TIME_REDIRECTION_MS } from "@dineout-cart-client/constants/Coupon";
import { COUPON_GROUP_TYPES } from "@swiggy-private/core-ui";
import {
    CheckoutActionTypes,
    DineoutCartRendererActionPayload,
    DineoutCartType,
} from "@swiggy-private/checkout-core";
import { isBillPaymentCart } from "@dineout-cart-client/helpers/cartHelper";

export const isBestCouponGroup = (type: COUPON_GROUP_TYPES) => {
    return type === COUPON_GROUP_TYPES.BEST_COUPON;
};

export const isGreatDealCouponGroup = (type: COUPON_GROUP_TYPES) => {
    return type === COUPON_GROUP_TYPES.GREAT_DEALS;
};

export const isPaymentOfferCouponGroup = (type?: COUPON_GROUP_TYPES): boolean => {
    return type === COUPON_GROUP_TYPES.PAYMENT_OFFERS;
};

export const shouldSkipCartReloadOnRedirection = (launchTimestamp: number): boolean => {
    const timeDiff = Date.now() - launchTimestamp;
    const skipCartReload = timeDiff <= CART_RELOAD_TIME_REDIRECTION_MS;
    return skipCartReload;
};

export function getPaymentOfferCoupons(coupons?: ICouponCard[] | null) {
    return coupons?.find((coupon: ICouponCard) => coupon.type === COUPON_GROUP_TYPES.PAYMENT_OFFERS);
}

export const getCartPageCheckoutState = (
    cartType: DineoutCartType | null,
): {
    type: CheckoutActionTypes.DINEOUT_BILL_PAYMENT_CART | CheckoutActionTypes.DINEOUT_TABLE_RESERVATION_CART;
    payload?: DineoutCartRendererActionPayload | null;
} => {
    if (isBillPaymentCart(cartType)) {
        return {
            type: CheckoutActionTypes.DINEOUT_BILL_PAYMENT_CART,
            payload: {
                skipCartReload: true,
            } as DineoutCartRendererActionPayload,
        };
    }

    return {
        type: CheckoutActionTypes.DINEOUT_TABLE_RESERVATION_CART,
        payload: null,
    };
};
